import { DefaultButton } from "../../../../common/components/button/defaultButton/DefaultButton";
import { NotificationsSectionStatus } from "../../../../common/enums";
import { IosInstallSteps } from "../../../notifications/IosInstallSteps";
import { useNotificationsSection } from "../hooks/useNotificationsSection";
import styles from "./NotificationsSection.module.scss";

export const NotificationsSection = () => {
  const { status, isBusy, onEnable, onDisable } = useNotificationsSection();

  return (
    <div className={styles.root}>
      <div className={styles.card}>
        <div className={styles.cardHeader}>
          <span className={styles.cardTitle}>Известия на това устройство</span>
          {status === NotificationsSectionStatus.Enabled && (
            <span className={`${styles.pill} ${styles.pillOn}`}>Включени</span>
          )}
          {status === NotificationsSectionStatus.Disabled && (
            <span className={styles.pill}>Изключени</span>
          )}
          {status === NotificationsSectionStatus.Blocked && (
            <span className={`${styles.pill} ${styles.pillBlocked}`}>Блокирани</span>
          )}
        </div>

        {status === null && <div className={styles.skeleton} />}

        {status === NotificationsSectionStatus.Enabled && (
          <>
            <p className={styles.text}>Ще получавате известия от обекта на това устройство.</p>
            <DefaultButton
              label="Изключи известията"
              design="outline"
              width="100%"
              loading={isBusy}
              disabled={isBusy}
              onClick={onDisable}
            />
          </>
        )}

        {status === NotificationsSectionStatus.Disabled && (
          <>
            <p className={styles.text}>
              Включете ги, за да получавате известия от обекта на това устройство.
            </p>
            <DefaultButton
              label="Включи известията"
              width="100%"
              loading={isBusy}
              disabled={isBusy}
              onClick={onEnable}
            />
          </>
        )}

        {status === NotificationsSectionStatus.Blocked && (
          <p className={styles.text}>
            Известията са блокирани за този сайт. Разрешете ги от настройките на браузъра или
            телефона си и презаредете страницата.
          </p>
        )}

        {status === NotificationsSectionStatus.IosInstall && (
          <>
            <p className={styles.text}>
              На iPhone известията работят, когато Planny е добавен на началния екран.
            </p>
            <IosInstallSteps />
          </>
        )}

        {status === NotificationsSectionStatus.Unsupported && (
          <p className={styles.text}>
            Този браузър не поддържа известия. Ако сте отворили Planny от Instagram или Facebook,
            отворете го в Chrome, Safari или Firefox.
          </p>
        )}
      </div>

      <p className={styles.hint}>Известията се включват отделно за всяко устройство.</p>
    </div>
  );
};
